import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MaterialTable, { MTableToolbar } from 'material-table'
import { ButtonListEdit } from 'theme'
import Pageview from '@material-ui/icons/Pageview'
import { ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED } from '../../actions/action-constants'
import SnackbarError from '../../components/snackbar/snackbar-error'
import CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'
class ArchivedReferrals extends Component {
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS
  constructor (props) {
    super(props)
    this.state = {
      setRowsPerPage: 20,
      data: [],
      columns: [
        { title: 'Sys ID', field: 'id' },
        { title: 'CP / REG ID', field: 'regid' },
        { title: 'Name', field: 'lcommafname' },
        { title: 'Program', field: 'programdescription' },
        { title: 'Rcvd Dte', field: 'referralreceiveddate' },
        { title: 'Aprv Dte', field: 'referralapproveddate' },
        { title: 'Denied Dte', field: 'referraldeniedadmissiondate' },
        { title: 'Outcome', field: 'referraloutcomesdescription' }
      ]
    }
  }
 
  componentDidMount () {
    const c_USER = this.context;
    this.props.getArchivedReferrals(c_USER.id)
    this.props.getProgramsAssignedToLoginList(c_USER.id)
  }

  render () {
    return (
      <div>
        {this.props.programsAssigned.length <= 1 ? (
          <div>
            <h4>{ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}</h4>
            <SnackbarError
              variant='error'
              message={ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}
            />
          </div>
        ) : (
          <div style={{ maxWidth: '100%' }}>
            <MaterialTable
              title='Archived Referrals'
              columns={this.state.columns}
              data={this.props.archivedreferrals}
              // onRowSelected='10'
              // rowData='10'
              // rowsperpage='10'
              // rows='10'
              rowsPerPage='10'
              options={{
                // search
                search: true,
                // header grouping
                grouping: true,
                // or
                // column filtering
                // filtering: true,
                // CSV export
                // pagination settings
                // show paging buttons
                // paging:false,
                // default items per page
                pageSize: 10,
                // paging options
                pageSizeOptions: [10, 25, 50, 100],
                // ???
                // columnsButton:false,
                // move buttons to right side of list
                // actionsColumnIndex: -1,
                // styling otions
                rowStyle: { height: '20px' },
                maxBodyHeight: 700,
                // export data buttons
                // exportButton: true,
                // default filename
                exportFileName: 'CPCMexport-ArchivedReferrals'
                // comma delimited
                // exportDelimiter: ',',
              }}
              actions={[
                {
                  // icon: 'details',
                  icon: 'pageview',
                  tooltip: 'View Archived Referral',
                  onClick: (event, rowData) => {
                    // this.props.history.push('/archivedreferrals/view/' + rowData.id);
                    this.props.history.push('/archivedreferrals/' + rowData.id)
                  }
                }
              ]}
              components={{
                Toolbar: props => (
                  <div
                    style={{
                      background:
                        'linear-gradient(45deg, #ff7961 10%, #fff 70%)', // blue / fade light blue
                      color: 'white'
                    }}>
                    <MTableToolbar {...props} />
                  </div>
                ),
                // this section can be removed does same with or without this custom button piece - start
                Action: props => (
                  <ButtonListEdit
                    onClick={event => props.action.onClick(event, props.data)}>
                    <Pageview />
                  </ButtonListEdit>
                )
                // this section can be removed does same with or without this custom button piece - end
              }}
            />
          </div>
        )}
      </div>
    )
  }
}
ArchivedReferrals.propTypes = {
  history: PropTypes.object
}
export default withRouter(ArchivedReferrals)
